import React, { useContext } from "react";
import { Box, Card, Grid, Typography } from "@mui/material";
import CustomerDetailsContext from "./context";

const StatCard = ({ title, value, color }) => {
  return (
    <Card
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 3,
        boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Accent bar */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 6,
          height: "100%",
          bgcolor: color,
        }}
      />

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          color: color,
          lineHeight: 1,
        }}
      >
        {value}
      </Typography>
    </Card>
  );
};

const Index = () => {
  const { balances } = useContext(CustomerDetailsContext);
  return (
    <Box
      // sx={{
      //   display: "grid",
      //   gridTemplateColumns: "repeat(3, 1fr)",
      //   gap: 3,
      //   flex: 1,
      // }}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4, lg: 4 }}>
          <StatCard
            title="Pontos Ganhos"
            value={balances.totalEarned}
            color="#2e7d32"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4, lg: 4 }}>
          <StatCard
            title="Pontos Resgatados"
            value={balances.totalRedeemed}
            color="#8d0000"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4, lg: 4 }}>
          <StatCard
            title="Saldo de Pontos"
            value={balances.balance}
            color="#00366d"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default React.memo(Index);
